<div class="trust-deed-upload-component">
  @if (requiredTrustDeeds.length) {
  <div class="row">
    <div class="col-12">
      <message-box type="info" title="Trust Deed Upload">
        <p>This application will require the following Trust Deeds. These can also be uploaded after
          submission.</p>
        <p>Providing them now improves assessment times. Deeds should be text-based PDFs rather than
          scans, so the trust's details can be read from them automatically.</p>
      </message-box>
    </div>
  </div>

  @for (deed of requiredTrustDeeds; track deed.value) {
  <div class="row separator-bottom">
    <div class="col-12">
      <upload-file
        [title]="deed.label"
        [subMessage]="deed.reason"
        [allowMultiple]="true"
        [maxFilesAllowed]="5"
        [mandatory]="false"
        [acceptFileTypes]="acceptFileTypes"
        (events)="onFilesSelected(deed, $event)"></upload-file>

      @if (uploadedFor(deed); as alreadyUploaded) {
      @if (alreadyUploaded.length) {
      <uploaded-files-list
        [uploadedFiles]="alreadyUploaded"
        [applicationId]="applicationId ?? undefined"
        [isAzureDocument]="true"
        (events)="onDeleteUploadedDoc($event.deletedFile)"></uploaded-files-list>
      }
      }
    </div>
  </div>
  }
  }
</div>
